import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTill } from '../context/TillContext';

/**
 * Route-level guard that requires an active till session.
 * Redirects to /sales/till/open with the current path in state so the
 * user returns here after opening the till.
 */
const TillGuardRoute: React.FC = () => {
  const { activeTill, loading } = useTill();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <div className="ims-loading-spinner" />
      </div>
    );
  }

  if (!activeTill) {
    return (
      <Navigate
        to="/sales/till/open"
        state={{ returnTo: location.pathname + location.search }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default TillGuardRoute;
